module.exports = __webpack_public_path__ + "68e34c8dce2cb09f7a9eb110b358dbbc.jpg";